import React from 'react';
import intl from 'react-intl-universal';

import Tooltip from '@mui/material/Tooltip';
import Fab from '@mui/material/Fab';
import IconButton from '@mui/material/IconButton';
import IconCreate from '@mui/icons-material/Add';
import IconFilterOn from '@mui/icons-material/FilterList';
import IconFilterOff from '@mui/icons-material/Close';
import ButtonWithProgress from '../../common/ButtonWithProgress';
import { Plugin, Template, TemplatePlaceholder } from '@devexpress/dx-react-core';

const Toolbar = ({
  readOnly,
  filtering,
  handleItemCreateClick,
  handleFilteringToggle,
  tooltips,
  title,
  subscription,
  handleExportClick,
}: {
  readOnly: boolean;
  filtering: boolean;
  handleItemCreateClick: () => void;
  handleFilteringToggle: () => void;
  tooltips: {
    create: string;
  };
  title: string;
  subscription: React.ReactNode;
  handleExportClick: () => void;
}) => (
  <Plugin name="ListViewToolbar" dependencies={[{ name: 'Toolbar' }]}>
    <Template name="toolbarContent">
      {!readOnly && (
        <Tooltip title={tooltips?.create}>
          <Fab size="small" color="primary" sx={{ flexShrink: 0 }} onClick={handleItemCreateClick}>
            <IconCreate />
          </Fab>
        </Tooltip>
      )}
      {title}
      <TemplatePlaceholder />
      <Tooltip
        title={
          filtering
            ? intl.get('board.views.list.tooltips.remove_filtering')
            : intl.get('board.views.list.tooltips.add_filtering')
        }
      >
        <IconButton onClick={handleFilteringToggle}>{filtering ? <IconFilterOff /> : <IconFilterOn />}</IconButton>
      </Tooltip>
      {subscription}
      <ButtonWithProgress
        buttonText={intl.get('board.views.list.tooltips.export')}
        tooltipText={intl.get('board.views.list.tooltips.export')}
        handleClick={handleExportClick}
      />
    </Template>
  </Plugin>
);

export default Toolbar;
